import './bml-stats.scss';
const TEMPLATE = `
<section class="precision-laboratory fade-up">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <p class="section-label" data-animate-child>Про нас у цифрах</p>
            </div>
            <div class="col-lg-6 col-md-6">
                <h3 data-animate-child data-delay="200">Довіра, підтверджена результатами</h3>
                <p data-animate-child data-delay="400">
                    Ми розробили процеси, що гарантують швидкість, точність і надійність результату кожного
                    дослідження. Наші показники відображають масштаб роботи лабораторії, довіру лікарів та стабільну
                    якість діагностики.
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-6 col-md-3 col-sm-6 precision-results" data-animate-child data-delay="200">
                <div class="stat-box">
                    <p class="stat-number">5 днів</p>
                    <p class="stat-description">Наш стандартний термін виконання патогістологічного дослідження</p>
                </div>
            </div>
            <div class="col-6 col-md-3 col-sm-6 precision-results" data-animate-child data-delay="400">
                <div class="stat-box">
                    <p class="stat-number">36 годин</p>
                    <p class="stat-description">Швидкість патогістологічного дослідження у термінових випадках</p>
                </div>
            </div>
            <div class="col-6 col-md-3 col-sm-6 precision-results" data-animate-child data-delay="600">
                <div class="stat-box">
                    <p class="stat-number">99,9%</p>
                    <p class="stat-description">Вірних діагнозів за результатами міжнародної системи зовнішньої оцінки якості (EQA)</p>
                </div>
            </div>
            <div class="col-6 col-md-3 col-sm-6 precision-results" data-animate-child data-delay="800">
                <div class="stat-box">
                    <p class="stat-number">до 15 хв</p>
                    <p class="stat-description">Час реакції нашої команди на будь-який робочий запит від партнерів</p>
                </div>
            </div>
        </div>
        <div class="video-section" data-animate-child data-delay="1000">
            <div class="video-wrapper" data-content="youtube-video" data-page="Home" data-attribute="video"
                 data-original-attribute="video">
                <img src="/images/video/image.png" alt="Мікроскопія в RMI" class="video-thumbnail">
                <button class="play-button"></button>
            </div>
        </div>
    </div>
</section>
`;

class BmlStats extends HTMLElement {
    connectedCallback() {
        if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE;
    }
}

customElements.define('bml-stats', BmlStats);
